import {Swiper,SwiperSlide} from "swiper/react";
import YouTube from "react-youtube";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-cube';
import 'swiper/css/effect-flip';
import 'swiper/css/effect-cards';
import "../styleSheets/showreelStyle.css"


import {EffectCube, EffectFlip, Navigation} from "swiper/modules";
export function Showreel({slides, modules = null}){
    const ytOpts = {
        width: "100%",
        height: "100%",
        playerVars: {
            rel: 0,
            modestbranding: 1,
        },
    };
    return (
        <div className={"wrapper"}>
            <Swiper
                modules={[Navigation,EffectCube,EffectFlip]}
                spaceBetween={50}
                slidesPerView={1}
                style={{
                    "--swiper-navigation-color": "white",
                }
                }
                effect = {modules}
                loop={true}

                navigation={true}
                scrollbar={{draggable: true}}
                onSlideChange={() =>console.log('slide change')}
                onSwiper={(swiper) => console.log(swiper)}
            >
                {slides.map((slide) => (
                    <SwiperSlide key ={slide.url}>
                        <div className={"video-wrapper"}>
                            <YouTube videoId={slide.url} opts={ytOpts}/>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}

